import Phaser from 'phaser';

const BG_OUTER = 0x14532d;
const BG_INNER = 0x166534;
const FIST_LIGHT = 0x4ade80;
const FIST_MID = 0x22c55e;
const FIST_DARK = 0x14532d;
const STROKE = 0x0a0f1f;

export function drawFist(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const palmW = r * 1.2;
  const palmH = r * 0.95;
  const palmX = -palmW / 2;
  const palmY = -palmH * 0.25;
  g.lineStyle(Math.max(1, Math.floor(stroke * 0.8)), STROKE, 1);
  g.fillStyle(FIST_MID, 1);
  g.fillRoundedRect(palmX, palmY, palmW, palmH, r * 0.2);
  g.strokeRoundedRect(palmX, palmY, palmW, palmH, r * 0.2);

  const knuckleW = palmW / 4;
  const knuckleH = r * 0.3;
  const knuckleY = palmY - knuckleH * 0.7;
  for (let i = 0; i < 4; i++) {
    const kx = palmX + knuckleW * (i + 0.5) - knuckleW / 2;
    g.fillStyle(FIST_LIGHT, 1);
    g.fillRoundedRect(kx + 2, knuckleY, knuckleW - 4, knuckleH, r * 0.08);
    g.strokeRoundedRect(kx + 2, knuckleY, knuckleW - 4, knuckleH, r * 0.08);
  }

  g.fillStyle(FIST_DARK, 0.85);
  for (let i = 1; i < 4; i++) {
    const lineX = palmX + knuckleW * i;
    g.fillRect(lineX - 1, palmY + palmH * 0.18, 2, palmH * 0.35);
  }

  const thumbW = r * 0.35;
  const thumbH = r * 0.55;
  g.fillStyle(FIST_MID, 1);
  g.fillRoundedRect(palmX + palmW * 0.82, palmY + palmH * 0.1, thumbW, thumbH, r * 0.12);
  g.strokeRoundedRect(palmX + palmW * 0.82, palmY + palmH * 0.1, thumbW, thumbH, r * 0.12);
}
